import axios from 'axios';
import qs from 'qs';

const AUTH_URL = process.env.REACT_APP_AUTH;
const AUTH_APP_NAME = process.env.REACT_APP_AUTH_APP_NAME;
const SMART_CLIENT_URL = process.env.REACT_APP_CLIENT_DATA;
const SMART_REPORT_URL = process.env.REACT_APP_SMART_REPORT;
const PAYMENT_API = process.env.REACT_APP_PAYMENT;

// Request interceptor
axios.interceptors.request.use((config) => config, (error) => Promise.reject(error));

// Response interceptor
axios.interceptors.response.use((response) => response, (error) => {
  const { status } = error.response;
  if (status === 401) {
    localStorage.clear();
    window.location.replace('/');
  }
  return Promise.reject(error);
});

export const TwoFactorAuth = (otp, session) => axios({
  method: 'POST',
  url: `${AUTH_URL}/auth/2-factor?otp=${otp}&session=${session}`,
});

export const resendOTP = (session) => axios({
  method: 'POST',
  url: `${AUTH_URL}/auth/2-factor/otp?session=${session}`,
});

export const LoginAuth = ({ username, password }) => axios({
  method: 'POST',
  headers: { 'content-type': 'application/x-www-form-urlencoded', channel: 'markaz-usr', appName: AUTH_APP_NAME },
  url: `${AUTH_URL}/auth/login`,
  data: qs.stringify({ username, password }),
});

export const getDashboardData = (token) => axios({
  method: 'GET',
  headers: { Authorization: `Bearer ${token}` },
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicants`,
});

export const validateToken = (token) => axios({
  method: 'POST',
  url: `${AUTH_URL}/auth/token`,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const logout = (token) => axios({
  method: 'GET',
  url: `${AUTH_URL}/sso/logout`,
  headers: {
    Authorization: `Bearer ${token}`,
  },
  withCredentials: true,
});

export const requestInvalidateToken = (token) => axios({
  method: 'POST',
  url: `${AUTH_URL}/quit?token=${token}`,
});

export const getDashboardUserById = (token, id) => axios({
  method: 'GET',
  headers: { Authorization: `Bearer ${token}` },
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicants/${id}`,
});

export const getApplicantById = (id, token) => axios({
  method: 'GET',
  headers: { Authorization: `Bearer ${token}` },
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${id}`,
});

export const geti18n = (token) => axios({
  method: 'GET',
  headers: { Authorization: `Bearer ${token}` },
  url: `${SMART_CLIENT_URL}/markaz/i18n`,
});

export const updateApplicant = (data, token) => axios({
  method: 'POST',
  headers: { Authorization: `Bearer ${token}` },
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/status`,
  data,
});

export const getFilePdf = (url, token) => axios({
  method: 'GET',
  headers: { Authorization: `Bearer: ${token}` },
  responseType: 'blob',
  url: `${SMART_CLIENT_URL}${url}`,
});

export const getPDFSimulation = (refCode) => axios({
  method: 'GET',
  responseType: 'blob',
  url: `${SMART_REPORT_URL}`,
  params: {
    channel: 'markaz',
    refCode,
  },
});

export const generateOtp = (phone, token) => {
  // const url = AUTH_URL.replace('/auth', '/magic-otp');
  const url = process.env.REACT_APP_GENERATE_OTP;
  return axios({
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      channel: 'markaz-cob-mo',
      Authorization: `Bearer ${token}`,
    },
    url,
    data: qs.stringify({ username: phone }),
  });
};

export const getApplicantDetailById = (id, token) => axios({
  method: 'GET',
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${id}/details`,
  headers: { Authorization: `Bearer ${token}` },
});

export const getApplicantMoStatus = (applicantId, token) => axios({
  method: 'GET',
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/mo-status`,
  headers: { Authorization: `Bearer ${token}` },
});

export const postApplicantMoStatus = (applicantId, token, data) => axios({
  method: 'POST',
  url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/mo-status`,
  headers: { Authorization: `Bearer ${token}` },
  data,
});

export const saveAssetAllocationPdf = async (applicantId, token, data) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = axios({
      method: 'POST',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/asset-allocation`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      data,
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const saveCustomSubPortfolioPdf = async (applicantId, token, data) => {
  try {
    const res = axios({
      method: 'POST',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/custom/sub-pf`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      data,
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const getSubPfPdf = async (applicantId, token) => {
  try {
    const response = await axios({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        // principal: 'principal',
      },
      responseType: 'blob',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/custom/sub-pf`,
    });

    // Create a Blob from the PDF Stream
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    downloadURI(fileURL, 'custom-sub-pf');
    return Promise.resolve(fileURL);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

export const getUploadedCustomFiles = (applicantId, token) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = axios({
      method: 'GET',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/custom/filenames`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};
export const saveCivilIDAndPassport = async (applicantId, token, data, type) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = axios({
      method: 'PATCH',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/asset/${type}`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      data,
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const toggleCRN = async (applicantId, token, crnRequired) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = axios({
      method: 'PATCH',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/crn/required?crnRequired=${crnRequired}`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },

    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const getIntl = async (token) => {
  try {
    const response = await axios({
      method: 'GET',
      headers: { Authorization: `Bearer: ${token}` },
      url: `${SMART_CLIENT_URL}/markaz/i18n`,
    });
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};
export const getInitOptions = async (token) => {
  try {
    const response = await axios({
      method: 'GET',
      headers: { Authorization: `Bearer: ${token}` },
      url: `${SMART_CLIENT_URL}/markaz/initialize-data`,
    });
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

export const getCustomfileByName = async (applicantId, token, name) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = await axios({
      method: 'GET',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/asset/file?fileName=${name}`,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    const file = new Blob(
      [res.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    downloadURI(fileURL, name);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const deleteCustomfileByName = async (applicantId, token, name) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = await axios({
      method: 'DELETE',
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${applicantId}/asset/file?fileName=${name}`,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const getPDF = async (token, phone, pdfType) => {
  try {
    const response = await axios({
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: 'principal',
      },
      responseType: 'blob',
      url: `${SMART_CLIENT_URL}/markaz/pdf?phone=${phone}&type=${pdfType}`,
    });
    // Create a Blob from the PDF Stream
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    downloadURI(fileURL, 'asset allocation');
    return Promise.resolve(fileURL);
    // return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

// export const updateApplicantInfo = (id, token, data) => {
//   axios({
//     method: 'PATCH',
//     headers: { Authorization: `Bearer ${token}` },
//     url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${id}`,
//     data,
//   });
// };

export const updateApplicantInfo = async (id, token, data) => {
  try {
    // const res = await axios.post(`${API_URL}/user`, body);
    const res = await axios({
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}` },
      url: `${SMART_CLIENT_URL}/markaz/middle-office/applicant/${id}`,
      data,
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error.response);
  }
};

function downloadURI(uri, name) {
  const link = document.createElement('a');
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link.remove();
}

// Payment history
export const getPaymentHistory = async (token: string, email: string) => {
  try {
    const response = await axios({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${PAYMENT_API}/result/history?username=${email}`,
    });
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};
